export default __webpack_public_path__ + "static/poster-d93778314fae96473d00cd9cf668ace9.png";